import axios from './../../libs/api.request'

export function add (data) {
  return axios.request({
    url: '/customer/add',
    method: 'post',
    data
  })
}

export function update (data) {
  return axios.request({
    url: '/customer/update',
    method: 'post',
    data
  })
}

export function importByUrl (data) {
  return axios.request({
    url: '/customer/import',
    method: 'post',
    data
  })
}

export function queryCustomer (data) {
  return axios.request({
    url: '/customer/list',
    method: 'post',
    data
  })
}

export function operationByPath (path) {
  return axios.request({
    url: path,
    method: 'get'
  })
}

export function deleteByIds (data) {
  return axios.request({
    url: '/customer/deleteByIds',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/components/customer/customerApi.js